import React from "react"

// styling and images
import images from "../../../../images"
import "./Hero.scss"

function Hero() {
  return (
    <div id="v-hero">
      <div className="image">
        <img src={images.hero.winter} alt="Appentura - Paar" />
        <div className="poison-gas"></div>
      </div>
      <div id="v-hero-claim">
        <div id="v-hero-claim-inner">
          <div id="v-hero-claim-primary">Überrasche deine Liebsten</div>
          <div id="v-hero-claim-secondary-1">Du stellst die Überraschung zusammen und</div>
          <div id="v-hero-claim-secondary-2">wir führen per Smartphone durch das Erlebnis.</div>
        </div>
      </div>
    </div>
  )
}

export default Hero